import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  useCanRender,
  useFeatureFlag,
  useStorage,
} from '../../../../hooks';
import type { RootState } from '../../../../store/models';
import { PublicProvider } from '../../../../api/Providers';

export const useProfileSentimentSurvey = (proInfo: Pick<PublicProvider, 'creation_time' | 'id'>) => {
  const {
    creation_time,
    id,
  } = proInfo || {};
  const {
    loading,
    enabled,
  } = useFeatureFlag('pro_profile_launch_survey_fly_2065_20200720');
  const localForageKey = `profileLaunchSurvey-${id}`;
  const [surveyComplete] = useStorage(localForageKey);
  const isNewPro = moment().isBefore(
    moment(creation_time).add(28, 'days'),
  );
  const isProvider = useSelector<RootState, boolean>(
    state => !!state.user.providerId,
  );
  const canRender = useCanRender(
    !!proInfo,
    !loading,
    enabled,
    isNewPro,
    !isProvider,
    !surveyComplete,
  );

  return canRender;
};
